import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";

const NAV_LINKS = [
  { href: "#hero", label: "Accueil" },
  { href: "#about", label: "À propos" },
  { href: "#services", label: "Services" },
  { href: "#why-us", label: "Pourquoi nous" },
  { href: "#team", label: "Équipe" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        <Logo variant="navbar" />

        <nav className="hidden lg:flex items-center gap-7 whitespace-nowrap">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="nav-link text-sm whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-3">
          <a
            href="tel:+22505053527272"
            data-testid="navbar-call-btn"
            className="flex items-center gap-2 text-sm font-semibold text-[#0A1128] hover:text-[#D90429] transition-colors whitespace-nowrap"
          >
            <Phone size={16} />
            +225 05 05 35 27 27
          </a>
          <a href="#contact" data-testid="navbar-quote-btn" className="kms-btn-primary text-sm whitespace-nowrap">
            Devis
          </a>
        </div>

        <div className="hidden lg:flex xl:hidden">
          <a href="#contact" data-testid="navbar-quote-btn-md" className="kms-btn-primary text-sm whitespace-nowrap">
            Demander un devis
          </a>
        </div>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden flex items-center justify-center w-10 h-10 text-[#0A1128]"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-gray-100 mt-3 px-6 py-6 space-y-4 shadow-lg"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-base font-semibold text-[#0A1128] hover:text-[#D90429]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="kms-btn-primary w-full justify-center mt-4"
          >
            Demander un devis
          </a>
        </div>
      )}
    </header>
  );
}
